import { render } from "./select-themes.vue?vue&type=template&id=552814ad"
import script from "./select-themes.vue?vue&type=script&lang=js"
export * from "./select-themes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__